export default {
  // these cycle definitions start at the smallest dot index
  closed: {
    "2684": "diamond",
    "125": "triangle"
  },
  open: {
    "729": "arrow",
    "74523": "stair",
    "3215789": "sigma"
  }
};



// WEBPACK FOOTER //
// ./src/constants/runes.js